<template>
  <b-row
    class="summary-row"
    :class="{
      'summary-row-error':showStatus && creationStatus === 'error',
      'summary-row-deleted':showStatus && creationStatus === 'deleted',
      'summary-row-creating':showStatus && creationStatus === 'creating',
      'summary-row-success':showStatus && creationStatus && creationStatus !== 'error',
    }"
  >
    <b-col cols="8" class="summary-row-text">
      {{ text }}
    </b-col>
    <b-col cols="4">
      <template-status v-if="status && showStatus" :status="status" />
    </b-col>
  </b-row>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import TemplateStatus from "@/components/template/_template-status";
import {mapGetters} from "vuex";

export default {
  name: "SummaryRow",
  components: { TemplateStatus },
  props: {
    text: {
      type: String,
      default: "",
    },
    creationStatus: {
      type: String,
      default: "",
    },
    showStatus:{
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      status: "",
    };
  },
  watch: {
    creationStatus: function () {
      this.calculateCreationStatus();
    },
  },
  created() {
    this.calculateCreationStatus()
  },
  computed:{
    ...mapGetters(['getCreatedIds'])
  },
  methods: {
    calculateCreationStatus(){
      if(this.showStatus) {
        if (!this.creationStatus) {
          this.status = "toBeCreated";
        } else if (this.creationStatus === "creating") {
          this.status = "pending";
        }
      else if (this.creationStatus === "deleted") {
          this.status = "deleted";
        }
        else if (this.creationStatus === "error") {
          this.status = "error";
        } else if (this.creationStatus !== "error") {
          this.status = "success";
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.summary-row{
  padding: 15px;
  border-bottom: 1px solid #afafaf;
  border-top: 1px solid #afafaf;
  &-success {
    background: #00ff004f;
  }
  &-error{
    background: #ff00005c;
  }
  &-deleted{
    background: #afafaf;
  }
  &-creating{
  background:   #fff3004f
  }
  &-text {
    font-size: 20px;
  }
  }
</style>
